import { numberIsSet } from '@app/src/utils/helpers'
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowRightOutlined,
  KeyboardDoubleArrowUp,
} from '@mui/icons-material'
import type { Palette } from '@mui/material/styles'
import { useTheme } from '@mui/styles'
import React from 'react'

interface DiamondIconProps extends React.SVGProps<SVGSVGElement> {
  style?: React.CSSProperties
}

const DiamondIcon = (props: DiamondIconProps) => {
  const color = props.style?.color ?? '#000'
  return (
    <svg viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g shapeRendering="crispEdges">
        <path d="M11 14 4 7l7-7 7 7zm0-2.85L15.15 7 11 2.85 6.85 7z" fill={color} />
        <path d="M17.293 7 11 13.293 4.707 7 11 .707zM6.143 7 11 11.857 15.857 7 11 2.143z" stroke={color} />
      </g>
    </svg>
  )
}

const getDeviationIconStyle = (deviation: number | undefined, palette: Palette) => {
  if (!numberIsSet(deviation)) return { icon: DiamondIcon, iconColor: palette.text.secondary }
  if (deviation <= -100) return { icon: KeyboardDoubleArrowDown, iconColor: palette.semantic.error }
  if (deviation < 0) return { icon: KeyboardArrowDown, iconColor: palette.text.secondary }
  if (deviation === 0) return { icon: KeyboardDoubleArrowRightOutlined, iconColor: palette.text.secondary }
  if (deviation < 100) return { icon: KeyboardArrowUp, iconColor: palette.text.secondary }
  return { icon: KeyboardDoubleArrowUp, iconColor: palette.semantic.error }
}

interface DeviationIconProps {
  deviation: number | undefined
  noMargin?: boolean
}

export const DeviationIcon: React.FC<DeviationIconProps> = ({ deviation, noMargin = false }) => {
  const { spacing, palette } = useTheme()

  const deviationIconStyling = getDeviationIconStyle(deviation, palette)

  return React.createElement(deviationIconStyling.icon, {
    width: 24,
    height: 24,
    style: { color: deviationIconStyling.iconColor, ...(noMargin ? {} : { marginRight: spacing(1) }) },
  })
}
